//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@api/manage';
export default {
  name: 'FactorQualifiedModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  data: function data() {
    return {
      title: '因子合格范围表单',
      tableName: 'site_factor_qualified',
      form_fields: ['siteId', 'factorId', 'dataType', 'timeType', 'mistakeType', 'errorValue', 'tenantId'],
      form_fields_time: [],
      validatorRules: {
        factorId: {
          rules: [{
            required: true,
            message: '请选择因子!'
          }]
        },
        dataType: {
          rules: [{
            required: true,
            message: '请选择数据类型!'
          }]
        },
        timeType: {
          rules: [{
            required: true,
            message: '请选择时间类型!'
          }]
        },
        mistakeType: {
          rules: [{
            required: true,
            message: '请选择合格范围!'
          }]
        }
      },
      siteFactorList: [],
      url: {
        querySiteFactor: '/site/factor/qualified/querySiteFactor/'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    add: function add(siteId) {
      console.log('record', siteId);
      if (undefined == siteId) this.$message.warning('请选择单个站点');
      this.loadSiteFactorList(siteId);
      this.edit({
        siteId: siteId
      });
    },
    loadSiteFactorList: function loadSiteFactorList(params) {
      var that = this;
      that.siteFactorList = [];
      getAction(this.url.querySiteFactor + params).then(function (res) {
        if (res.success) {
          that.siteFactorList = res.result;
        }
      });
    }
  }
};